<template>
  <div id="app">
    <Navbar />
      <router-view class="box">
      </router-view>
    <Base/>
  </div>
</template>

<script>
import Navbar from './views/navbar'
import Base from './views/Base'
export default {
  components: {
    Navbar,
    Base
  }
}
</script>
<style lang="scss" scoped>
@import url("./assets/css/normalize.css");
* {
  // -webkit-text-size-adjust: none;
 padding: 0;
  margin: 0;
  font-weight: 400;
  font-family:"Microsoft YaHei"
}
@media only screen and (max-width: 750px) {
.box{
margin-top: 170px;
}

}

@media only screen and (min-width: 756px) {
.box{
  margin-top: 100px*100/192;
}
}
</style>
